{
  "REGISTER": {
    "TRY_WOOT": "Konto erstellen",
    "GET_STARTED": "Mit Chatwoot loslegen",
    "TITLE": "Registrieren",
    "TESTIMONIAL_HEADER": "Alles, was er braucht, ist ein Schritt, um vorwärtszugehen",
    "TESTIMONIAL_CONTENT": "Sie sind nur noch einen Schritt davon entfernt, Ihre Kunden zu gewinnen, zu binden und neue zu finden.",
    "TERMS_ACCEPT": "Durch die Erstellung eines Kontos stimmen Sie unseren <a href=\"https://www.chatwoot.com/terms-of-service\">Allgemeinn Geschäftsbedingungen</a> und unserer <a href=\"https://www.chatwoot.com/privacy-policy\">Datenschutzrichtlinie</a> zu",
    "OAUTH": {
      "GOOGLE_SIGNUP": "Mit Google anmelden"
    },
    "COMPANY_NAME": {
      "LABEL": "Firmenname",
      "PLACEHOLDER": "Geben Sie Ihren Firmennamen ein, z. B.: Wayne Enterprises",
      "ERROR": "Firmenname ist zu kurz"
    },
    "FULL_NAME": {
      "LABEL": "Vollständiger Name",
      "PLACEHOLDER": "Geben Sie Ihren vollständigen Namen ein, z. B.: Bruce Wayne",
      "ERROR": "Vollständiger Name ist zu kurz"
    },
    "EMAIL": {
      "LABEL": "Geschäftliche E-Mail-Adresse",
      "PLACEHOLDER": "Enter your work email address. E.g., bruce{'@'}wayne{'.'}enterprises",
      "ERROR": "Bitte geben Sie eine gültige Arbeits-E-Mail-Adresse ein"
    },
    "PASSWORD": {
      "LABEL": "Passwort",
      "PLACEHOLDER": "Passwort",
      "ERROR": "Das Passwort ist zu kurz",
      "IS_INVALID_PASSWORD": "Das Passwort sollte mindestens 1 Großbuchstaben, 1 Kleinbuchstaben, 1 Ziffer und 1 Sonderzeichen enthalten",
      "REQUIREMENTS_LENGTH": "At least 6 characters long",
      "REQUIREMENTS_UPPERCASE": "At least one uppercase letter",
      "REQUIREMENTS_LOWERCASE": "At least one lowercase letter",
      "REQUIREMENTS_NUMBER": "At least one number",
      "REQUIREMENTS_SPECIAL": "At least one special character"
    },
    "CONFIRM_PASSWORD": {
      "LABEL": "Bestätige das Passwort",
      "PLACEHOLDER": "Bestätige das Passwort",
      "ERROR": "Passwörter stimmen nicht überein."
    },
    "API": {
      "SUCCESS_MESSAGE": "Registration Successful",
      "ERROR_MESSAGE": "Es konnte keine Verbindung zum Woot Server hergestellt werden. Bitte versuchen Sie es später erneut"
    },
    "SUBMIT": "Konto erstellen",
    "HAVE_AN_ACCOUNT": "Haben Sie bereits ein Konto?",
    "VERIFY_EMAIL": {
      "TITLE": "Check your inbox",
      "DESCRIPTION": "We sent a verification link to {email}. Click the link to verify your email and get started.",
      "RESEND": "Verifizierungs-E-Mail erneut senden",
      "RESEND_SUCCESS": "Verification email sent. Please check your inbox.",
      "RESEND_ERROR": "Could not send verification email. Please try again."
    }
  }
}
